import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../constants';
import { FormGenerator } from '../../helper/FormGenerator';
import { xorEncrypt } from '../../utils/xorCrypto';
import { useTokens } from '../../context/TokenContext';

const ChangePassword = ({ id }) => {
  const { getItem } = useTokens();
  const vendorAuthToken = getItem('vendor', 'AuthToken');
  const [loading, setLoading] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [isPasswordMatch, setIsPasswordMatch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    oldpassword: '',
    password: '',
    confirmPassword: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const toastId = toast.loading('Changing password...', { autoClose: false });

    const formDataToSubmit = {
      oldPassword: formData.oldpassword,
      newPassword: xorEncrypt(formData.password),
    };

    try {
      const response = await axios.post(`${API_URL}/vendor/change-password`, formDataToSubmit, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${vendorAuthToken}`,
        },
      });

      toast.update(toastId, {
        render: 'Password changed successfully!',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: error?.response?.data?.message || 'Failed to change password. Please try again.',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    }
    setLoading(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <h2>Change Password</h2>
      <p>Update your password below.</p>

      <form onSubmit={handleFormSubmit}>
        <div className='row'>
          <FormGenerator
            fields={[
              {
                id: "oldpassword",
                label: "Old Password",
                type: "password",
                minLength: 8,
                class: "col-md-7",
                required: true,
              },
              {
                id: "password",
                label: "Password",
                type: "password",
                minLength: 8,
                class: "col-md-7",
                required: true,
                hint:
                  "Password must be at least 8 characters long and contain both letters and numbers.",
              },
              {
                id: "confirm_password",
                label: "Confirm Password",
                type: "password",
                matchWith: "password",
                class: "col-md-7",
                required: true,
              },
            ]}
            fieldData={formData}
            onChange={(field, value) => setFormData(prev => ({ ...prev, [field]: value }))}
            onSubmit={false}
            hTure={false}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
